export default "__VITE_ASSET__BpCKAWhB__"